function getAnchorScrollOffset(link, target) {
  if (link.hasAttribute('data-scroll-offset')) {
    return parseInt(link.dataset.scrollOffset, 10) || 0;
  }
  return parseInt(target.dataset.scrollOffset || '0', 10) || 0;
}

function getScrollElement(target) {
  return target.querySelector('[data-plan-cta-button]') || target;
}

function scrollToAnchorTarget(link, target) {
  const scrollElement = getScrollElement(target);
  const offset = getAnchorScrollOffset(link, target);
  const rect = scrollElement.getBoundingClientRect();
  const elementCenter = rect.top + window.scrollY + rect.height / 2;
  const top = elementCenter - window.innerHeight / 2 - offset;
  window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
}

function handleAnchorClick(event) {
  const link = event.target.closest('a[href*="#"]');
  if (!link) return;

  const href = link.getAttribute('href');
  if (!href || href === '#') return;

  let hash;
  try {
    hash = new URL(link.href, window.location.href).hash;
  } catch (error) {
    return;
  }

  if (!hash || hash.length < 2) return;

  const target = document.getElementById(hash.slice(1));
  if (!target || !target.hasAttribute('data-anchor-target')) return;

  event.preventDefault();
  scrollToAnchorTarget(link, target);
}

if (!window.__anchorScrollInitialized) {
  window.__anchorScrollInitialized = true;
  document.addEventListener('click', handleAnchorClick, true);
}
